export default __webpack_public_path__ + "static/media/Pot3.cb154f35.svg";